var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinGtaAttOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14033_27824)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13C0 5.8 5.8 0 13 0C20.2 0 26 5.8 26 13C26 20.2 20.2 26 13 26C5.8 26 0 20.2 0 13Z",
    fill: "#979797",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3 5.80078H8.00002H6.70002C6.50002 5.80078 6.40002 5.90078 6.40002 6.10078V6.70078V9.30078V18.7008C6.40002 18.9008 6.50002 19.0008 6.70002 19.0008H10.9L13 20.7008L15.2 19.0008H16.2H18.7H19.3C19.5 19.0008 19.6 18.9008 19.6 18.7008V17.4008V6.10078C19.7 5.90078 19.5 5.80078 19.3 5.80078Z",
    fill: "#979797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7 4.80078C20.4 4.50078 20 4.30078 19.5 4.30078H6.50005C6.10005 4.30078 5.70005 4.50078 5.30005 4.80078C5.00005 5.10078 4.80005 5.50078 4.80005 6.00078V19.0008C4.80005 19.4008 5.00005 19.8008 5.30005 20.2008C5.60005 20.6008 6.00005 20.7008 6.50005 20.7008H10.2L13 23.5008L15.8 20.7008H19.5C19.9 20.7008 20.3 20.5008 20.7 20.2008C21 19.9008 21.2 19.5008 21.2 19.0008V6.00078C21.2 5.50078 21.1 5.10078 20.7 4.80078ZM19.7 17.4008V18.7008C19.7 18.9008 19.6 19.0008 19.4 19.0008H18.8H16.3H15.3L13.1 20.7008L10.9 19.0008H6.70005C6.50005 19.0008 6.40005 18.9008 6.40005 18.7008V9.20078V6.70078V6.10078C6.40005 5.90078 6.50005 5.80078 6.70005 5.80078H8.00005H19.3C19.5 5.80078 19.6 5.90078 19.6 6.10078V17.4008H19.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 9.10234C13.9001 9.10234 14.7001 9.90234 14.7001 10.8023H15.4001C15.4001 9.50234 14.3001 8.40234 13.0001 8.40234C11.7001 8.40234 10.6001 9.50234 10.6001 10.8023H11.3001C11.3001 9.90234 12.1001 9.10234 13.0001 9.10234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 7.10156C10.9001 7.10156 9.20007 8.80156 9.20007 10.9016H9.90007C9.90007 9.20156 11.3001 7.80156 13.0001 7.80156C14.7001 7.80156 16.1001 9.20156 16.1001 10.9016H16.8001C16.8001 8.70156 15.1001 7.10156 13.0001 7.10156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9 12.0023H13.4V11.6023C13.7 11.5023 13.9 11.2023 13.9 10.8023C13.9 10.3023 13.5 9.90234 13 9.90234C12.5 9.90234 12.1 10.3023 12.1 10.8023C12.1 11.1023 12.3 11.4023 12.6 11.6023V12.0023H11.1H10.4V12.7023V16.3023V17.0023H11.1H14.8H15.5V16.3023V12.7023V12.0023H14.9ZM14.4 13.5023V15.5023V15.9023H14H11.9H11.5V15.5023V13.5023V13.1023H11.9H14H14.4V13.5023Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14033_27824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinGtaAttOffline);
export default __webpack_public_path__ + "static/media/pin_gta_att_offline.d72e5321c2b5964f80b8f8459311408f.svg";
export { ForwardRef as ReactComponent };